import { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";
import { useUser } from "src/shared/context/UserContext";
import noImage from "src/assets/Images/imetanic-logo.png";
import { formatTerms, ThermalPrinterTestProps } from "./PrintConfigration";
import { COMPANY_NAME } from "src/shared/utils/brand";
import { Button } from "src/business-types/grocery/components/Button";
import CommonButtons from "src/shared/components/CommonButtons";

const ThermalPrinter1: React.FC<ThermalPrinterTestProps> = ({ PrintData, BtnName, username, openPrint, isClosed, ledgerPaid, barcodeTrue, icon, className }) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState<string>("");
  const { user, userConfigration } = useUser();

  const roundAmount = (value: any): string => {
    const num = Number(value);
    if (isNaN(num)) {
      return "0.00";
    }
    const rounded = Math.round(num * 100) / 100;
    return rounded.toFixed(2);
  };

  const formatNumber = (value: number) => {
    return value < 1000 ? value.toString().padStart(4, "0") : value.toString();
  };

  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const parcelFeeEnabled = toBoolean(userConfigration?.parcelFeeEnabled);
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = userConfigration?.orderIdEnabled !== undefined ? toBoolean(userConfigration?.orderIdEnabled) : true;
  const enabileTermsAndConditions = toBoolean(userConfigration?.enableTermsAndConditions);

  const generateOrderList = () => {
    return `
      <table style="width: 95%; margin: 10px; border-collapse: collapse; font-size: 20px">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 5px;">S.No</th>
            <th style="border: 1px solid black; padding: 5px; text-align: left;">Product Name <br/> دولة قط</th>
            <th style="border: 1px solid black; padding: 5px;">Price <br/> السعر<br/>(ر.ق)</th>
            <th style="border: 1px solid black; padding: 5px;">Qty <br/> كمية</th>
            <th style="border: 1px solid black; padding: 5px;">Amount <br/> كمية<br/>(ر.ق)</th>
          </tr>
        </thead>
        <tbody>
          ${PrintData?.Products?.map(
            (product, index) => `
            <tr>
              <td style="border: 1px solid black; padding: 5px; text-align: center;">${index + 1}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: left;">${product.productName} <br/> ${product.arabicword}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(product.amount)}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${product.quantity} ${PrintData?.businessType === "Grocery" ? product.uom?.substring(0, 3).toLowerCase() : ""}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(product.totalPrice)}</td>
            </tr>
          `,
          ).join("")}
        </tbody>
      </table>
    `;
  };

  const carwashorderdetails = () => {
    const printDataAny = PrintData as any;
    const cars = printDataAny?.cars || [];
    const allProducts = PrintData?.Products || [];

    if (cars.length === 0 && allProducts.length === 0) {
      return "<div>No order data available</div>";
    }

    const formatPrice = (price: any) => {
      const num = Number(price);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    };

    let vehiclesCount = 0;
    let grandTotal = 0;

    const carsHtml = cars
      .map((car: any, index: number) => {
        vehiclesCount++;
        let carSubtotal = 0;

        const products = car?.services?.[0]?.productDetails || [];

        if (products.length === 0) return "";

        const productRows = products
          .map((product: any) => {
            const price = Number(product.price) || 0;
            carSubtotal += price;
            grandTotal += price;

            return `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <div style="padding-left: 15px;">${product.product || ""}</div>
              <div>${formatPrice(price)}</div>
            </div>
          `;
          })
          .join("");

        return `
        <div style="margin-top: 12px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${car.carNumber || `CAR-${index + 1}`}</div>
          ${productRows}
          <div style="display: flex; justify-content: space-between; padding: 4px 0; border-top: 1px dotted #ccc; margin-top: 4px; font-weight: bold;">
            <div>Car ${index + 1} Subtotal</div>
            <div>${formatPrice(carSubtotal)}</div>
          </div>
        </div>
      `;
      })
      .join("");

    return `
    <div style="margin: 15px 0;">
      <div style="font-weight: bold; margin-bottom: 15px; text-align: center;">
        MULTI-CAR ORDER - ${vehiclesCount} VEHICLES
      </div>
      
      ${carsHtml}
      
      <div style="border-top: 1px solid #000; margin: 15px 0 10px;"></div>
      
      <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
        <div>Vehicles:</div>
        <div>${vehiclesCount} cars</div>
      </div>
      
      <div style="display: flex; justify-content: space-between; font-weight: bold;">
        <div>Total:</div>
        <div>${formatPrice(grandTotal)}</div>
      </div>
    </div>
  `;
  };

  const customerDetails = () => {
    const billNoHtml = billNoEnabled && PrintData?.billNo ? `<p><strong>Bill No.:</strong> ${formatNumber(PrintData.billNo)}</p>` : "";
    const orderIdHtml = orderIdEnabled && PrintData?.OrderId ? `<p><strong>Order ID (رقم الطلب):</strong> ${PrintData?.OrderId}</p>` : "";
    return `
    <table style="width: 100%; margin-bottom: 10px; border-top: 1px solid black; font-size: 20px">
      <tr>
        <td style="width: 50%; border-bottom: 1px solid black;">
          ${orderIdHtml}
          ${billNoHtml}
          <p><strong>Date | Time :</strong> ${PrintData?.Date ?? ""} | ${PrintData?.Time ?? ""}</p>
        </td>
      </tr>

      <tr>
  <td style="width: 50%;">
  <p><strong>Customer Details</strong></p>

  <p><strong>Name:</strong> ${PrintData?.CustomerName ?? ""}</p>
  <p><strong>Phone:</strong> ${PrintData?.CustomerPhon ?? ""}</p>

  ${
    PrintData?.clientId
      ? `
      <div style="margin-top: 4px; overflow: auto; width: 100%;">
        <div style="float: left;">
          <strong>Client Id:</strong> ${PrintData.clientId}
        </div>
        <div style="float: right;">
          ${PrintData?.paymentMethod ? `<strong>Type:</strong> ${PrintData.paymentMethod}` : ""}
        </div>
      </div>
    `
      : `
      ${PrintData?.paymentMethod ? `<p><strong>Type:</strong> ${PrintData.paymentMethod}</p>` : ""}
    `
  }
</td>
</tr>
    </table>
  `;
  };

  const orderPrice = () => {
    return `
    <div style="width: 100%; padding: 5px; border-bottom: 1px solid black;">

      <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>Sub Total (المجموع الفرعي):</strong>
        ${roundAmount(PrintData?.total)} ر.ق
      </p>

      ${
        parcelFeeEnabled
          ? `
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Parcel Fee (رسوم الطرود):</strong>
          +${roundAmount(PrintData?.parcelFee)} ر.ق
        </p>
      `
          : ""
      }

      <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>Discount (تخفيض):</strong>
        -${roundAmount(PrintData?.discount)} ر.ق
      </p>

      ${
        deliveryFeeEnabled
          ? `
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Delivery Fee (رسوم التوصيل):</strong>
          +${roundAmount(PrintData?.deliveryFee)} ر.ق
        </p>
      `
          : ""
      }

      ${tipsEnabled && PrintData 
          ? `<p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Tip (نصيحة):</strong> +${roundAmount(PrintData?.Tip || PrintData?.tip)} ر.ق
        </p>`
          : ""
      }

      <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>Total (المجموع):</strong>
        ${roundAmount(PrintData?.subtotal)} ر.ق
      </p>

    </div>
  `;
  };

  const pay1 = () => {
    return `
    <div style="width: 100%; padding: 5px; border-bottom: 1px solid black;">
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Paid (مدفوع):</strong> ${roundAmount(Number(PrintData?.Paid) || 0)} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Total Paid (مدفوع):</strong>${roundAmount(Number(PrintData?.payMentHistory?.reduce((sum, item) => sum + (Number(item.paidAmount) || 0), 0) ?? 0))} ر.ق ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Amount Due (المبلغ المتبقي):</strong> ${roundAmount(PrintData?.unpaid)} ر.ق
        </p>
      </div>`;
  };

  const pay2 = () => {
    return `
     <div style="width: 100%; padding: 5px; border-bottom: 1px solid black;">
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Prev. Paid (مدفوع):</strong> ${roundAmount(Number(PrintData?.prvPaid) || 0)} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Prev. Balance (المبلغ المتبقي):</strong> ${roundAmount(PrintData?.prvBalance)} ر.ق
        </p>
      </div>
    `;
  };

  const businessTypes = user?.businessType || "";

  const printHistory = () => {
    if (!PrintData?.payMentHistory || PrintData?.payMentHistory.length === 0) return "";

    return `
    <div style="margin-top: 10px;">
      <h3 style="text-align: center;">Payment History (سجل الدفع)</h3>
      <table style="width: 100%; border-collapse: collapse; font-size: 20px; margin-top: 5px;">
        <thead>
          <tr>
          <th style="border: 1px solid black; padding: 5px;">Date</th>
            <th style="border: 1px solid black; padding: 5px;">Method</th>
            <th style="border: 1px solid black; padding: 5px;">paid</th>
            <th style="border: 1px solid black; padding: 5px;">Received</th>
            <th style="border: 1px solid black; padding: 5px;">Balance</th>
            <th style="border: 1px solid black; padding: 5px;">Return</th>

          </tr>
        </thead>
        <tbody>
          ${PrintData.payMentHistory
            .map(
              (item) => `
            <tr>
              <td style="border: 1px solid black; padding: 5px; text-align: center;">${item.date ?? item.payment_on}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: center;">${item.Paymentmethod}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(item.paidAmount)}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(item.ReceivedAmount)}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(item.balance)}</td>
              <td style="border: 1px solid black; padding: 5px; text-align: right;">${roundAmount(item.balanceReturned || 0)}</td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>
    </div>
  `;
  };

   const ledgerBalance = `${roundAmount( Math.abs(Number(ledgerPaid?.PreviousBalance || 0)) - Math.abs(Number(ledgerPaid?.Paid || 0)) - Math.abs(Number(ledgerPaid?.discount || 0)))}`;

  const ledgerList = () => {
    return `
    <div style="with:100%">
      <table style="width: 100%; margin-bottom: 10px; border-top: 1px solid black; font-size: 20px">
       <tr>
          <td style="width: 50%; border-bottom: 1px solid black;">
            <p><strong>Date | Time :</strong> ${ledgerPaid?.Date} | ${ledgerPaid?.Time}</p>
          </td>
        </tr>
        <tr>
          <td style="width: 50%; border-bottom: 1px solid black;">
            <p><strong>Customer Details</strong></p>
            <p><strong>Name:</strong> ${ledgerPaid?.CustomerName}</p>
            <p><strong>Phone:</strong> ${ledgerPaid?.CustomerPhon}</p>
            ${billNoEnabled ? `<div><strong>Bill No:</strong> ${ledgerPaid?.billNo ? `<strong>${formatNumber(ledgerPaid?.billNo)}</strong>` : ""}</div>` : ""}
            <p><strong>Client Id:</strong> ${ledgerPaid?.clientId ? ledgerPaid.clientId : "null"}</p>
          </td>
        </tr>
      </table>
       <div style="width: 100%; border-bottom: 1px solid black;">
        <p style="display: flex; justify-content: space-between; width: 98%;">
           <strong>${ledgerPaid?.previousLabel || "Prev. Balance"}:</strong>
            ${roundAmount(Math.abs(Number(ledgerPaid?.PreviousBalance || 0)))} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%; border-bottom: 1px solid black">
          <strong>Discount(تخفيض):</strong>
            ${roundAmount(Math.abs(Number(ledgerPaid?.discount) || 0))} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%; border-bottom: 1px solid black">
          <strong>${ledgerPaid?.paidLabel || "Balance Paid"}:</strong>
            ${roundAmount(Math.abs(Number(ledgerPaid?.Paid) || 0))} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>${ledgerPaid?.balanceLabel || "New Balance"}:</strong>
          ${ledgerBalance} ر.ق
        </p>
      </div>
    </div>
   `;
  };

  const content = `
    <div style="font-family: monospace; padding: 10px; color: black; font-size: 20px; font-family: "Times New Roman", Times, serif;">
    <div>
      <h1 style="text-align: center;"></h1>
     </div>
    <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; text-align: center;">
       <!-- Logo -->
                ${
                  user?.companyLogo
                    ? `<img
         src="${user?.companyLogo}"
         onerror="this.src=${noImage}"
         style="width: 100px; height: 100px; border-radius: 50%;" />`
                    : `<img src="${noImage}" style="width: 60px; height: 60px; border-radius: 8px; object-fit: contain;" />`
                }
       <!-- Business Name -->
       <h1 style="margin: 0; padding: 2px; width: 100%; max-width: 600px; word-wrap: break-word;">${user?.orgName}</h1>
       
        <!-- Business Arabic Name -->
          <h1 style="margin: 0; padding: 2px; width: 100%; max-width: 600px; word-wrap: break-word;">${user?.orgArabicName ?? ""}</h1>

         <!-- Business Location -->
          <h2 style="margin: 0; padding: 2px; width: 100%; max-width: 600px; word-wrap: break-word;">${user?.businessLocation ?? ""}</h2>

        <!-- Phone Number -->
       <p style="margin: 0; padding: 5px;">${user?.phones?.[0]?.phone || ""}</p>
    </div>

    
      ${PrintData ? customerDetails() : ""}
      ${PrintData ? (businessTypes === "Carwash" ? carwashorderdetails() : "") : ""}
      ${PrintData ? (businessTypes !== "Carwash" ? generateOrderList() : "") : ""}
      ${PrintData ? orderPrice() : ""}
      ${PrintData?.prvPaid ? pay2() : ""}
      ${ledgerPaid ? ledgerList() : ""}

    ${PrintData ?
         `<div style="width: 100%; padding: 5px; border-bottom: 1px solid black;">
      
       <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>Paid (مدفوع):</strong> ${roundAmount(Number(PrintData?.Paid) || 0)} ر.ق
      </p>

      ${
        parseFloat(String(PrintData?.prvBalance) || "0") < 0
          ? `
      <p style="display: flex; justify-content: space-between; width: 98%; border-top: 1px solid black; padding-top: 5px;">
       <strong>Previous OSB (الرصيد السابق):</strong> ${roundAmount(Math.abs(Number(PrintData?.prvBalance ?? 0)))} ر.ق
      </p>`
          : ""
      }
      <p style="display: flex; justify-content: space-between; width: 98%;">
        <strong>Amount Due (المبلغ المتبقي):</strong> ${roundAmount(PrintData?.unpaid)} ر.ق
      </p>
      ${
        Number(PrintData?.returnAmount) > 0
          ? `
      <p style="display: flex; justify-content: space-between; width: 98%;">
          <strong>Return (المبلغ الراجع):</strong> ${roundAmount(PrintData?.returnAmount)} ر.ق
      </p>
          `
          : ""
      }
      <p style="display: flex; justify-content: space-between; width: 98%; border-top: 1px solid black; padding-top: 5px;">
       <strong>Outstanding Balance (الرصيد المتبقي):</strong> ${roundAmount(Number(PrintData?.OSB) || 0)} ر.ق
     </p>${
       PrintData?.resvedAmount
         ? `
        <div style="display:flex; justify-content:space-between; border-top:1px dashed #000; padding-top:5px;"><span>Received Amount(ر.ق):</span> <span>${roundAmount(
          PrintData?.resvedAmount,
        )} </span></div>
        <div style="display:flex; justify-content:space-between;"><span> paid Amount(ر.ق):</span> <span>${roundAmount(PrintData?.Paid)} </span></div>
        <div style="display:flex; justify-content:space-between;"><span> Balance Amount(ر.ق):</span> <span>${roundAmount(Number(PrintData?.resvedAmount) - PrintData?.Paid)} </span></div>
        `
         : ""
     }
   </div>`
        : ""
    }
      ${barcodeTrue ? `<div style="text-align: center; margin-top: 10px;"><img src="${barcodeDataUrl}" alt="Barcode" /></div>` : ""}
      ${PrintData?.payMentHistoryAvabile ? printHistory() : ""} 
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsEnglish ? `<div style="margin-top:10px;"><strong>Terms and Conditions:</strong><p>${formatTerms(userConfigration.termsAndConditionsEnglish)}</p></div>` : ""}
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsArabic ? `<div style="margin-top:10px;"><strong>Terms and Conditions (Arabic):</strong><p>${formatTerms(userConfigration.termsAndConditionsArabic)}</p></div>` : ""}
     <div style="margin-top:10px; display:flex; justify-content:center;">
  ${
    userConfigration?.contact_qr_codeAWS
      ? `<div style="flex:1; text-align:center;">
           <strong>Contact QR</strong><br/>
           <img src="${userConfigration.contact_qr_codeAWS}" style="width:160px; height:160px;" />
         </div>`
      : ""
  }
  ${
    userConfigration?.location_qr_codeAWS
      ? `<div style="flex:1; text-align:center;">
           <strong>Location QR</strong><br/>
           <img src="${userConfigration.location_qr_codeAWS}" style="width:160px; height:160px;" />
         </div>`
      : ""
  }
</div>
     <div style="text-align: center; margin-top: 20px; border-top: 1px solid black; padding-top: 10px;">
      <p style="text-align: center;">Thanks for visiting ${user?.orgName || COMPANY_NAME}</p>
      <p style="text-align: center;">Powered by ${COMPANY_NAME}</p>
    </div>
`;
  const handlePrint = () => {
    if (!isDisabled) {
      setIsDisabled(true);
      const printWindow = document.createElement("iframe");
      printWindow.style.position = "absolute";
      printWindow.style.width = "0";
      printWindow.style.height = "0";
      printWindow.style.border = "none";
      document.body.appendChild(printWindow);

      const printDoc = printWindow.contentWindow?.document;

      if (printDoc) {
        printDoc.open();

        // 🔥 Add 2 copies in the same print with page-break
        const finalPrintContent = `
        <div style="page-break-after: always;">
          ${content}
        </div>
        ${
          userConfigration?.copyQty > 1
            ? `<div>
          ${content}
        </div>`
            : ""
        }
      `;
        let doc = `
        <html>
          <head>
            <style>
              @media print {
                @page { margin: 0; }
                body { margin: 0; padding: 10px; font-size: 22px; }
              }
            </style>
          </head>
          <body>${finalPrintContent}</body>
        </html>
      `;

        printDoc.write(doc);
        printDoc.close();

        printWindow.onload = () => {
          try {
            printWindow.contentWindow?.focus();
            printWindow.contentWindow?.print();
          } catch (error) {
            console.error("Error triggering print:", error);
          } finally {
            setIsDisabled(false);
            isClosed?.(false);
          }
        };
      } else {
        console.error("Failed to access iframe content document.");
      }
    }
  };

  useEffect(() => {
    if (PrintData?.OrderId) {
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, String(PrintData.OrderId), {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
      });
      setBarcodeDataUrl(canvas.toDataURL("image/png"));
    }
  }, [openPrint]);

  useEffect(() => {
    if (openPrint && barcodeDataUrl) {
      handlePrint();
    }
  }, [barcodeDataUrl]);

  useEffect(() => {
    if (ledgerPaid && openPrint) {
      handlePrint();
    }
  }, [ledgerPaid]);

  return (
    <div>
      {(BtnName || icon) &&
        (user?.businessType === "Grocery" ? (
          <Button className={className} label={BtnName} onClick={handlePrint} icon={icon} radius="rounded-full" font="font-bold" />
        ) : (
          <CommonButtons label={BtnName} onClick={handlePrint} icon={icon} className={className} />
        ))}
    </div>
  );
};

export default ThermalPrinter1;
